var builttBoost;
setTimeout(function () {
  var b = jQuery;
  setTimeout(function () {
    builttBoost.init()
  });
  b(window).resize(function () {
    builttBoost.initMobileMenu()
  });
  b(window).scroll(function () {
    200 < b(this).scrollTop() ? b("#back-top").fadeIn() : b("#back-top").fadeOut()
  });
  b(document).on("click touchstart", function (d) {
    var g = b(".quick-view"),
      e = b("#dropdown-cart"),
      f = b("#cartToggle"),
      c = b("#email-modal .modal-window");
    g.is(d.target) || 0 !== g.has(d.target).length || e.is(d.target) || 0 !== e.has(d.target).length || f.is(d.target) || 0 !== f.has(d.target).length || c.is(d.target) || 0 !==
      c.has(d.target).length 
  });
  b(document).keyup(function (d) {
    27 == d.keyCode && (clearTimeout(builttBoost.avenuesTimeout), b(".modal").is(":visible") && b(".modal").fadeOut(500))
  });
  builttBoost = {
    avenuesTimeout: null,
    init: function () {
      this.updateDropdownCart()
    },

    updateDropdownCart: function () {
      Shopify.getCart(function (b) {
        builttBoost.doUpdateDropdownCart(b)
      })
    },
    doUpdateDropdownCart: function (d) {
      b("#cartCount").text(d.item_count);
      b("#dropdown-cart .summary .price").html(Shopify.formatMoney(d.total_price, window.money_format));
      b("#dropdown-cart .mini-products-list").html("");
      if (0 < d.item_count) {
        for (var g = 0; g < d.items.length; g++) {
          var e = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>',
            e = e.replace(/\{ID\}/g, d.items[g].id),
            e = e.replace(/\{URL\}/g, d.items[g].url),
            e = e.replace(/\{TITLE\}/g, d.items[g].title),
            e = e.replace(/\{QUANTITY\}/g, d.items[g].quantity),
            e = e.replace(/\{IMAGE\}/g, Shopify.resizeImage(d.items[g].image, "small")),
            e = e.replace(/\{PRICE\}/g, Shopify.formatMoney(d.items[g].price, window.money_format));
          b("#dropdown-cart .mini-products-list").append(e)
        }
        b("#dropdown-cart .btn-remove").click(function (d) {
          d.preventDefault();
          d = b(this).parents(".item").attr("id");
          d = d.match(/\d+/g);
          Shopify.removeItem(d,
            function (b) {
              builttBoost.doUpdateDropdownCart(b)
            })
        });
      }
    }
  }
});
class BuilttQuickAddToCart extends HTMLElement {
  constructor() {
    super();
    const wrapperTriggers = this.querySelectorAll('.js-wrapper-trigger')
    const wrapper = this.querySelector('.js-wrapper');
    const variantTriggers = this.querySelectorAll('.js-variant-trigger')
    const quickAddToCart = this.querySelector('.js-add-to-cart-button');
    let variantID = this.dataset.variant

    wrapperTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        wrapper.classList.toggle('is-active')
      })
    });

    variantTriggers.forEach(variantTrigger => {
      variantTrigger.addEventListener('click', (e) => {
        variantID = e.target.dataset.id
        variantTrigger.parentElement.parentElement.classList.add('variant-selected');
        quickAddToCart.classList.add('variant-is-selected')

        variantTriggers.forEach(item => {
          item.classList.remove('is-active')
          item.parentElement.classList.remove('is-selected')
        })

        e.target.parentElement.classList.add('is-selected')
        e.target.classList.add('is-active')
      })
    })

    if (variantID !== "") {
      quickAddToCart.addEventListener('click', (e) => {
        e.preventDefault();
        quickAddToCart.classList.add('adding')

        let items = [{
          id: `${variantID}`,
          quantity: 1
        }]
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(
            { items: items }
          )
        }).then(() => {
          quickAddToCart.classList.remove('adding')
          quickAddToCart.classList.add('is-added')
          builttBoost.updateDropdownCart();
          setTimeout(() => {
            quickAddToCart.classList.remove('is-added', 'variant-is-selected')
            variantTriggers.forEach(item => {
              item.classList.remove('is-active')
              item.parentElement.classList.remove('is-selected')
              item.parentElement.parentElement.classList.remove('variant-selected');
            })
          }, 1000);
        })
      })
    }
    
  }
}

customElements.define('builtt-quick-add-to-cart', BuilttQuickAddToCart);  